/*import React from 'react';
import './Subtotal.css';
import CurrencyFormat from 'react-currency-format';
import { useStateValue } from './StateProvider';
import { getBasketTotal } from './reducer';
import { Link, useNavigate} from "react-router-dom";

function Subtotal() {
  const navigate = useNavigate();
  const [{basket}] = useStateValue();


  return (
    <div className='subtotal'>
      <CurrencyFormat renderText={(value) => (
        <>
            <p>
                Totale parziale ({basket.reduce((acc, item) => acc + item.quantity, 0)} articoli):
                <strong>{value}</strong>
            </p>
        </>
      )} 
      decimalScale={2}
      value={getBasketTotal(basket)}
      displayType={'text'}
      thousandSeparator={true}
      prefix={'€'}
      />
      <button onClick={e => navigate('/payment')}>Procedi con il pagamento</button>
    </div>
  )
}

export default Subtotal*/

import React from 'react';
import './Subtotal.css';
import CurrencyFormat from 'react-currency-format';
import { useStateValue } from './StateProvider';
import { getBasketTotal } from './reducer';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

function Subtotal() {
  const navigate = useNavigate();
  const [{ basket, user }] = useStateValue();

  const handleProceedToPayment = () => {
    // 1. Controllo Accesso (Priorità)
    if (!user) {
      toast.error("Devi prima effettuare l'accesso per procedere al pagamento!", { autoClose: 5000 }, {
        toastId: "login-required-toast" // Impedisce duplicati visivi
      });
      navigate('/checkout');
      return;
    }

    // 2. Controllo Carrello Vuoto
    if (!basket || basket.length === 0) {
      toast.warn("Il tuo carrello è vuoto! Aggiungi dei prodotti prima del pagamento.", { autoClose: 5000 }, {
        toastId: "empty-cart-toast" // Impedisce duplicati visivi
      });
      return;
    }

    // 3. Se loggato e con carrello pieno, vai alla pagina di pagamento
    navigate('/payment');
  };

  return (
    <div className='subtotal'>
      <CurrencyFormat 
        renderText={(value) => (
          <p>
            Totale parziale ({basket.reduce((acc, item) => acc + item.quantity, 0)} articoli):
            <strong>{value}</strong>
          </p>
        )} 
        decimalScale={2}
        value={getBasketTotal(basket)}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'€'}
      />
      <button onClick={handleProceedToPayment}>Procedi con il pagamento</button>
    </div>
  );
}

export default Subtotal;
